import Swiper, { Autoplay, Navigation } from 'swiper';

let filtersSwiperWr = document.querySelectorAll('.filters-swiper-wr');
filtersSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
     let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 0,
      slidesPerView: 'auto',
      threshold: 10,
      slideToClickedSlide: true,
    });
  }
});

window.radioFilterToggle = function radioFilterToggle(radio, callback) {
  if (radio.dataset.waschecked === 'true') {
    radio.checked = false;
    radio.dataset.waschecked = 'false';
  } else {
    const group = document.getElementsByName(radio.name);
    group.forEach(r => r.dataset.waschecked = 'false');

    radio.dataset.waschecked = 'true';
    radio.checked = true;
  }

  if (typeof callback === 'function') {
    callback(radio.checked, radio);
  }
};